import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isOpen: false,
}

const uiAgencySwitcher = createSlice({
  name: 'uiAgencySwitcher',
  initialState,
  reducers: {
    open: state => {
      state.isOpen = true
    },
    close: state => {
      state.isOpen = false
    },
  },
})

const { reducer, actions: events } = uiAgencySwitcher

export { events, reducer as agencySwitcherReducer }
